import React from 'react'
import CV from "../assets/eu-cv_en.pdf"


const Cta = () => {
  return (
    <div className="cta">
        <a href={CV} download className="btn">Download CV</a>
        <a href="#contact" className="btn btn-primary">Contact me</a>
    </div>
  )
}

export default Cta